import script from "./SelectSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectSearch.vue?vue&type=script&setup=true&lang=js"

import "./SelectSearch.vue?vue&type=style&index=0&id=ca34488e&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca34488e"]])

export default __exports__